import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { AdminKeygenPage } from './admin-keygen';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [AdminKeygenPage],
    imports: [PagesModule, ComponentsModule]
})
export class AdminKeygenPageModule {}
